import { render, staticRenderFns } from "./BitacoraDetail.vue?vue&type=template&id=115682a8&scoped=true&"
import script from "./BitacoraDetail.vue?vue&type=script&lang=js&"
export * from "./BitacoraDetail.vue?vue&type=script&lang=js&"
import style0 from "./BitacoraDetail.vue?vue&type=style&index=0&id=115682a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115682a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
